import { render, staticRenderFns } from "./businessCenter.vue?vue&type=template&id=22648d6c&scoped=true"
import script from "./businessCenter.vue?vue&type=script&lang=js"
export * from "./businessCenter.vue?vue&type=script&lang=js"
import style0 from "./businessCenter.vue?vue&type=style&index=0&id=22648d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22648d6c",
  null
  
)

export default component.exports